module.exports = __webpack_public_path__ + "img/about-icon-7.85adfa2e.png";